<template>
  <div class="main">
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <h2><span></span>{{ $route.meta.cardTitle }}</h2>
    <el-card class="box-card" v-if="$route.meta.showCard">
      <router-view />
    </el-card>
    <router-view v-else />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.main {
  h2 {
    font-weight: 500;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 26px;
    margin: 11px 0 27px;
  }
  ::v-deep .box-card {
    min-height: 70vh;
    box-shadow: none;
    border: none;
    overflow: visible;
    position: relative;
    .el-card__body {
      padding: 30px 24px;
    }
  }
}
</style>
